import forOwn from 'mout/object/forOwn'

export default function getOneTrueNode(nodes) {
  let once = false
  let node = null
  forOwn(nodes, (val, key) => {
    if (val && !once) {
      node = key
      once = true
    }
  })
  return node
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getOneTrueNode.js